import request from '@/utils/request'
const qs = require('qs')

// export function listPerTagihan(data) {
//     return request({
//         url: '/report_pembelian/list_per_tagihan',
//         method: 'POST',
//         data: qs.stringify(data) // untuk array data post
//     })
// }

export function listPerSupplier(data) {
  return request({
    url: '/report_pembelian/list_per_supplier',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerSupplier(data) {
  return request({
    url: '/report_pembelian/total_trx_per_supplier',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerProduct(data) {
  return request({
    url: '/report_pembelian/list_per_product',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerProduct(data) {
  return request({
    url: '/report_pembelian/total_trx_per_product',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerTagihan(data) {
  return request({
    url: '/report_pembelian/list_per_tagihan',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerTagihan(data) {
  return request({
    url: '/report_pembelian/total_trx_per_tagihan',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerUmurPiutang(data) {
  return request({
    url: '/report_pembelian/list_per_umur_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerUmurPiutang(data) {
  return request({
    url: '/report_pembelian/total_trx_per_umur_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerHutang(data) {
  return request({
    url: '/report_pembelian/list_data_hutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportPurchase.js